/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';

//Includes
import { ALL_ROUTES, HOME_TODAY_SCREEN, API_CONSTANTS, PERMISSION_CONSTANTS, COMMON, SYNC_SERVICE } from '../../global/Constants';
import './home-today.css';
import { HeaderTypes, HomeActivityType, ActivityStatusType, ActivityType, CROP_GROUP } from "../../global/Enum";
import AuthService from '../../providers/AuthService';
import SyncServices from '../../providers/SyncServices';
import DataProvider from '../../providers/DataProvider';
import SyncLoader from '../common/loader/SyncLoader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Utilities from '../../global/Utilities';
import ApiServices from "../../providers/ApiServices";

//Components
import Header from '../common/Header';
import ActivityItem from '../common/ActivityItem';
import Footer from '../common/Footer';
import DesktopFooter from '../common/DesktopFooter';
import Loader from '../common/loader/Loader';


class ManagerFdoDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            selectedActivity: HomeActivityType.INDIVIDUAL_VISIT_FARMER,
            selectedFDO: null,
            activityList: [],
            pendingActivityList: [],
            fdoList: [],
            todayData: null,
            searchedValue: '',
            selectedActivityItem: null,
            mobileNumber: '',
            krishakInfo: null,
            startTime: null,
            endTime: null,
            isLoading: false,
            selectedDate: Utilities.getCurrentDate(),
            retailerInfo: null,
            hostFarmerName: '',
            isHost: false,

            isSyncLoading: false,
            tableName: SYNC_SERVICE.MASTER_TABLE
        }
        this.searchTimerHandle = null;
    }

    async componentDidMount() {
        toast.configure();
        await DataProvider.getInstance().fetchMasterData();
        if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
            if (this.props.location.state) {
                //Utilities.LogPrint("FDO Details-data", this.props.location.state.data);
                const data = this.props.location.state.data;
                this.setState({
                    user: data,
                }, () => {
                    //With Offline
                    const session = AuthService.getSession();
                    if (data.user_id === session?.user.user_id) {
                        this.getTodayFDOActivities(data.user_id);

                    } else if (data.is_employee === 1) {
                        //this.getTodayTMActivities(data.user_id);
                        this.getTodayFDOActivities(data.user_id);

                    } else {
                        this.getTodayFDOActivities(data.user_id);
                    }
                });
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }

        this.getActivityFDOApi();
        //With Online
        //this.getTodayActivityApi();
    }


    getTodayFDOActivities = (userId) => {
        //this.setState({ isLoading: true });
        SyncServices.getFDOActivitiesById(userId).then(data => {
            //this.setState({ isLoading: false });
            Utilities.LogPrint('FDO All Activity', data);

            if (data !== undefined || data !== null) {
                let activities = [];
                let todayData = {
                    IV: 0,
                    SD: 0,
                    GM: 0,
                    S2S: 0,
                };
                for (let i = 0; i < data?.todayActivities.length; i++) {
                    const activity = data?.todayActivities[i];

                    // For Activity Count
                    if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT) {
                        todayData.IV = todayData.IV + 1;
                    } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
                        todayData.SD = todayData.SD + 1;
                    } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                        todayData.GM = todayData.GM + 1;
                    } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                        todayData.S2S = todayData.S2S + 1;
                    }
                    //Utilities.LogPrint("Activity Count =====> ", todayData);

                    let activity_type_name, activity_tag, dataObj = null;

                    // For Today Activity
                    if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
                        activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_FARMER;
                        activity_tag = `IVF${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id !== 0) {
                        activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_RETAILER;
                        activity_tag = `IVR${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
                        activity_type_name = HomeActivityType.SAMPLE_DISTRIBUTION;
                        activity_tag = `SD${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                        activity_type_name = HomeActivityType.GROUP_MEET;
                        activity_tag = `GM${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                        //activity_type_name = HomeActivityType.SAMPLE_TO_SALE;
                        activity_type_name = Utilities.getActivityStageName(activity.stage_id);
                        activity_tag = `S2S${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;
                        dataObj = activity?.data;
                    }

                    let activityObj = {
                        key: activity?.key,
                        activity_id: activity?.activity_id,
                        activity_type_id: activity.activity_type_id,
                        activity_type_name: activity_type_name,
                        assigned_user_id: activity.assigned_user_id,
                        user_id: activity.user_id,
                        activity_tag: activity_tag,
                        activity_status_id: activity.activity_status_id,
                        crop_id: activity?.crop_id,
                        hybrid_id: activity?.hybrid_id,
                        village_id: activity?.village_id,
                        crop_name: DataProvider.getInstance().getCropNameById(activity?.crop_id),
                        hybrid_name: DataProvider.getInstance().getHybridNameById(activity?.hybrid_id),
                        village_name: DataProvider.getInstance().getVillageNameById(activity?.village_id),
                        krishak_id: activity?.krishak_id,
                        retailer_id: activity?.retailer_id,
                        stage_id: activity?.stage_id ? activity?.stage_id : 0,
                        stage: activity?.stage,
                        reporting_mobile: activity?.reporting_mobile,
                        data: dataObj,
                        //activity_reject: activity?.activity_reject
                    }

                    activities.push(activityObj);
                }

                // For Pending Activities
                let pendingActivities = [];
                for (let i = 0; i < data?.pendingActivities.length; i++) {
                    const activity = data?.pendingActivities[i];

                    let activity_type_name, activity_tag, dataObj = null;
                    // For Today Activity
                    if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity?.retailer_id === 0) {
                        activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_FARMER;
                        activity_tag = `IVF${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity?.retailer_id > 0) {
                        activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_RETAILER;
                        activity_tag = `IVR${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
                        activity_type_name = HomeActivityType.SAMPLE_DISTRIBUTION;
                        activity_tag = `SD${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                        activity_type_name = HomeActivityType.GROUP_MEET;
                        activity_tag = `GM${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                        //activity_type_name = HomeActivityType.SAMPLE_TO_SALE;
                        activity_type_name = Utilities.getActivityStageName(activity.stage_id);
                        activity_tag = `S2S${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;
                        dataObj = activity?.data;
                    }

                    let activityObj = {
                        key: activity?.key,
                        activity_id: activity?.activity_id,
                        activity_type_id: activity.activity_type_id,
                        activity_type_name: activity_type_name,
                        assigned_user_id: activity.assigned_user_id,
                        user_id: activity.user_id,
                        activity_tag: activity_tag,
                        activity_status_id: activity.activity_status_id,
                        crop_id: activity?.crop_id,
                        hybrid_id: activity?.hybrid_id,
                        village_id: activity?.village_id,
                        crop_name: DataProvider.getInstance().getCropNameById(activity?.crop_id),
                        hybrid_name: DataProvider.getInstance().getHybridNameById(activity?.hybrid_id),
                        village_name: DataProvider.getInstance().getVillageNameById(activity?.village_id),
                        krishak_id: activity?.krishak_id,
                        retailer_id: activity?.retailer_id,
                        stage_id: activity?.stage_id ? activity?.stage_id : 0,
                        stage: activity?.stage,
                        reporting_mobile: activity?.reporting_mobile,
                        data: dataObj,
                        //activity_reject: activity?.activity_reject
                    }
                    pendingActivities.push(activityObj);
                }
                this.setState({
                    todayData: todayData,
                    activityList: activities,
                    pendingActivityList: pendingActivities,
                })
            }

            // const activities = data.filter(item => item.assigned_user_id === userId);
            // Utilities.LogPrint('FDO User Wise Activity', activities);
        });
    }

    getTodayTMActivities = (userId) => {
        //this.setState({ isLoading: true });
        SyncServices.getTMActivitiesById(userId).then(data => {
            //this.setState({ isLoading: false });
            Utilities.LogPrint('TM All Activity', data);

            if (data !== undefined || data !== null) {
                let activities = [];
                let todayData = {
                    IV: 0,
                    SD: 0,
                    GM: 0,
                    S2S: 0,
                };
                for (let i = 0; i < data?.todayActivities.length; i++) {
                    const activity = data?.todayActivities[i];

                    // For Activity Count
                    if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT) {
                        todayData.IV = todayData.IV + 1;
                    } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
                        todayData.SD = todayData.SD + 1;
                    } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                        todayData.GM = todayData.GM + 1;
                    } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                        todayData.S2S = todayData.S2S + 1;
                    }
                    //Utilities.LogPrint("Activity Count =====> ", todayData);

                    let activity_type_name, activity_tag, dataObj = null;

                    // For Today Activity
                    if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
                        activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_FARMER;
                        activity_tag = `IVF${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id !== 0) {
                        activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_RETAILER;
                        activity_tag = `IVR${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
                        activity_type_name = HomeActivityType.SAMPLE_DISTRIBUTION;
                        activity_tag = `SD${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                        activity_type_name = HomeActivityType.GROUP_MEET;
                        activity_tag = `GM${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                        //activity_type_name = HomeActivityType.SAMPLE_TO_SALE;
                        activity_type_name = Utilities.getActivityStageName(activity.stage_id);
                        activity_tag = `S2S${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;
                        dataObj = activity?.data;
                    }

                    let activityObj = {
                        key: activity?.key,
                        activity_id: activity?.activity_id,
                        activity_type_id: activity.activity_type_id,
                        activity_type_name: activity_type_name,
                        assigned_user_id: activity.assigned_user_id,
                        user_id: activity.user_id,
                        activity_tag: activity_tag,
                        activity_status_id: activity.activity_status_id,
                        crop_id: activity?.crop_id,
                        hybrid_id: activity?.hybrid_id,
                        village_id: activity?.village_id,
                        crop_name: DataProvider.getInstance().getCropNameById(activity?.crop_id),
                        hybrid_name: DataProvider.getInstance().getHybridNameById(activity?.hybrid_id),
                        village_name: DataProvider.getInstance().getVillageNameById(activity?.village_id),
                        krishak_id: activity?.krishak_id,
                        retailer_id: activity?.retailer_id,
                        stage_id: activity?.stage_id ? activity?.stage_id : 0,
                        stage: activity?.stage,
                        reporting_mobile: activity?.reporting_mobile,
                        data: dataObj,
                        //activity_reject: activity?.activity_reject
                    }

                    activities.push(activityObj);
                }

                // For Pending Activities
                let pendingActivities = [];
                for (let i = 0; i < data?.pendingActivities.length; i++) {
                    const activity = data?.pendingActivities[i];

                    let activity_type_name, activity_tag, dataObj = null;
                    // For Today Activity
                    if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity?.retailer_id === 0) {
                        activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_FARMER;
                        activity_tag = `IVF${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity?.retailer_id > 0) {
                        activity_type_name = HomeActivityType.INDIVIDUAL_VISIT_RETAILER;
                        activity_tag = `IVR${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
                        activity_type_name = HomeActivityType.SAMPLE_DISTRIBUTION;
                        activity_tag = `SD${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                        activity_type_name = HomeActivityType.GROUP_MEET;
                        activity_tag = `GM${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;

                    } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                        //activity_type_name = HomeActivityType.SAMPLE_TO_SALE;
                        activity_type_name = Utilities.getActivityStageName(activity.stage_id);
                        activity_tag = `S2S${activity?.activity_id > 0 ? Utilities.activityTag(activity.activity_id) : ''}`;
                        dataObj = activity?.data;
                    }

                    let activityObj = {
                        key: activity?.key,
                        activity_id: activity?.activity_id,
                        activity_type_id: activity.activity_type_id,
                        activity_type_name: activity_type_name,
                        assigned_user_id: activity.assigned_user_id,
                        user_id: activity.user_id,
                        activity_tag: activity_tag,
                        activity_status_id: activity.activity_status_id,
                        crop_id: activity?.crop_id,
                        hybrid_id: activity?.hybrid_id,
                        village_id: activity?.village_id,
                        crop_name: DataProvider.getInstance().getCropNameById(activity?.crop_id),
                        hybrid_name: DataProvider.getInstance().getHybridNameById(activity?.hybrid_id),
                        village_name: DataProvider.getInstance().getVillageNameById(activity?.village_id),
                        krishak_id: activity?.krishak_id,
                        retailer_id: activity?.retailer_id,
                        stage_id: activity?.stage_id ? activity?.stage_id : 0,
                        stage: activity?.stage,
                        reporting_mobile: activity?.reporting_mobile,
                        data: dataObj,
                        //activity_reject: activity?.activity_reject
                    }
                    pendingActivities.push(activityObj);
                }
                this.setState({
                    todayData: todayData,
                    activityList: activities,
                    pendingActivityList: pendingActivities,
                })
            }
            // const activities = data.filter(item => item.assigned_user_id === userId);
            // Utilities.LogPrint('FDO User Wise Activity', activities);
        });

    }


    handleBack = () => {
        this.props.history.goBack();
    }

    //Api Calls
    getActivityFDOApi = () => {
        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_EMPLOYEE, SYNC_SERVICE.MASTER_TABLE).then(users => {
            //Utilities.LogPrint("users:", users);
            //this.setState({ isLoading: false });
            if (users !== undefined && users !== null && users?.length > 0) {
                const session = AuthService.getSession();
                var user = users?.find(item => item.user_id === session?.user.user_id);
                if (user) {
                    user['name'] = "Self"
                }
                //Utilities.LogPrint('#fdoListArray', users);
                const firstLevelUsers = users.filter(item => (item.server_employee_id === session?.user.server_employee_id
                    || item.server_manager_id === session?.user.server_employee_id) && item.is_active === 1);

                this.setState({ fdoList: firstLevelUsers });
            }
        });

        // this.setState({ isLoading: true })
        // try {
        //     ApiServices.getActivityFDO()
        //         .then(response => {
        //             var status = response.success
        //             if (status) {
        //                 Utilities.LogPrint("_getActivityFDOApi", response.data.data);
        //                 let fdoListArray = response.data.data;
        //                 // grab the Array item which matchs the id "2"

        //                 const session = AuthService.getSession();
        //                 var user = fdoListArray?.find(item => item.user_id === session?.user.user_id);
        //                 if (user) {
        //                     user['name'] = "Self"
        //                 }
        //                 Utilities.LogPrint("fdoListArray", fdoListArray);
        //                 this.setState({ fdoList: fdoListArray, isLoading: false })
        //             }
        //             else {
        //                 this.setState({ isLoading: false });
        //             }
        //         })
        //         .catch(error => {
        //             Utilities.LogPrint("_getActivityFDOApi-Catch", error);
        //         });
        // }
        // catch (error) {
        //     Utilities.LogPrint("_getActivityFDOApi-Error", error);
        // }
    }

    getTodayActivityApi = () => {
        var params = JSON.stringify({
            toDayDate: Utilities.getCurrentDate(),
            assigned_user_id: this.props.location.state.data.user_id
        });
        Utilities.LogPrint('@params', params);
        try {
            ApiServices.getTodayActivity(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("_getTodayActivityApi", response.data.data);
                        let mTodayActivity = response.data.data.to_day_activities.map(v => ({ ...v, start_time: response.data.data.start_time, end_time: response.data.data.end_time }))
                        let mPendingActivity = response.data.data.pending_activities.map(v => ({ ...v, start_time: response.data.data.start_time, end_time: response.data.data.end_time }))
                        this.setState({
                            todayData: response.data.data,
                            startTime: response.data.data.start_time,
                            endTime: response.data.data.end_time,
                            activityList: mTodayActivity,
                            pendingActivityList: mPendingActivity,
                            isLoading: false
                        });
                    }
                    else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("_getTodayActivityApi-catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("_getTodayActivityApi-error", error);
        }
    }

    getKrishakByReferenceIdApi = () => {
        const { selectedActivityItem } = this.state;

        if (selectedActivityItem.retailer_id === 1) {
            const retailers = DataProvider.getInstance().getRetailers();
            Utilities.LogPrint("retailers", retailers);
            if (retailers !== null) {
                let retailer = retailers.find(item => item.phone === this.state.mobileNumber);
                if (retailer) {
                    Utilities.LogPrint("retailer", retailer);
                    this.setState({ retailerInfo: retailer }, () => {
                        this.handleListClick(selectedActivityItem);
                    });
                } else {
                    toast.info(COMMON.RETAILER_NOT_FOUND);
                }
            } else {
                toast.info(COMMON.RETAILER_NOT_FOUND);
            }

        } else {
            SyncServices.findKrishakFromDatabase("key", this.state.mobileNumber).then(data => {
                Utilities.LogPrint("getKrishakFromDatabase ==", data);
                if (data) {
                    if (data.is_active === undefined || data.is_active === null || data.is_active === 1 || data.is_active === true) {
                        this.setState({ krishakInfo: data }, () => {
                            this.handleListClick(selectedActivityItem);
                        });
                    } else {
                        toast.info(COMMON.KRISHAK_NOT_FOUND);
                    }
                } else {
                    toast.info(COMMON.KRISHAK_NOT_FOUND);
                }
            });
        }
    }

    //For Edit Plan Api
    _getActivityByIdApi = (item) => {
        Utilities.LogPrint("@selected Card Item", item);
        var params = JSON.stringify({
            activity_id: item.activity_id
        });
        try {
            ApiServices.getActivityById(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("@getActivityById", response.data);
                        const { fdoList } = this.state;
                        let activity = response.data;

                        //Find index of specific object using findIndex method.
                        let fdoIndex = fdoList.findIndex((obj => obj.user_id === activity.assigned_user_id));
                        let activityObj = {
                            isEdit: true,
                            editActivityId: item.activity_id,
                            selectedActivity: item.activity_type_name,
                            selectedActivityId: item.activity_type_id,
                            selectedFDO: fdoList[fdoIndex],
                            cropId: activity.crop.crop_id,
                            hybrid: { value: activity.hybrid.hybrid_id, label: activity.hybrid.season_name },
                            village: { value: activity.village.village_id, label: activity.village.village_name }
                        }
                        Utilities.LogPrint("@activityObj", activityObj);
                        this.props.history.push({
                            pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
                            state: {
                                isLoading: false,
                                selectedActivity: item.activity_type_name,
                                selectedActivityId: item.activity_type_id,
                                editActivity: activityObj
                            }
                        });
                    }
                    else {
                        this.setState({
                            isLoading: false,
                        })
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("getActivityById-Catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("getActivityById-Error", error);
        }
    }


    _handleChange = (e) => {
        if (this.searchTimerHandle != null) {
            clearTimeout(this.searchTimerHandle);
        }
        let value = e.target.value;
        Utilities.LogPrint("SEARCH", value);
        this.searchTimerHandle = setTimeout(() => {
            this.setState({ searchedValue: value })
        }, 1000);
    }

    verifyNumber = event => {
        const { value, maxLength } = event.target;
        const mobileNumber = value.slice(0, maxLength);
        this.setState({ mobileNumber });

        if (this.state.isHost && mobileNumber.length === 10) {
            console.log("Need To Check");
            this.getKrishakDetails(mobileNumber);
        }
    }

    getKrishakDetails = (mobileNumber) => {
        SyncServices.findKrishakFromDatabase("key", mobileNumber).then(data => {
            Utilities.LogPrint("getKrishakFromDatabase ==", data);
            if (data) {
                if (data.is_active === undefined || data.is_active === null || data.is_active === 1 || data.is_active === true) {
                    this.setState({
                        krishakInfo: data,
                        hostFarmerName: data?.name
                    });
                }
            } else {
                this.setState({ hostFarmerName: '' })
            }
        });
    }

    _handlePendingActivities = () => {
        this.props.history.push(ALL_ROUTES.MANAGER_HOME_TODAY_ROUTE);
    }

    _selectFDO = (obj, e) => {
        Utilities.LogPrint("selectedFDO", obj);
        e.preventDefault();
        this.setState({
            selectedFDO: obj,
        })
    }

    _handleAddActivity(selectedActivity) {
        const { selectedFDO, user } = this.state;
        this.setState({
            selectedActivity: selectedActivity,
        });
        switch (selectedActivity) {
            case HomeActivityType.INDIVIDUAL_VISIT_FARMER:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
                    state: { selectedActivity: HomeActivityType.INDIVIDUAL_VISIT_FARMER, selectedActivityId: 1, selectedFDO: selectedFDO }
                })
                break;
            case HomeActivityType.INDIVIDUAL_VISIT_RETAILER:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
                    state: { selectedActivity: HomeActivityType.INDIVIDUAL_VISIT_RETAILER, selectedActivityId: 1, selectedFDO: selectedFDO }
                })
                break;
            case HomeActivityType.SAMPLE_DISTRIBUTION:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
                    state: { selectedActivity: HomeActivityType.SAMPLE_DISTRIBUTION, selectedActivityId: 2, selectedFDO: user }
                });
                break;
            case HomeActivityType.GROUP_MEET:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
                    state: { selectedActivity: HomeActivityType.GROUP_MEET, selectedActivityId: 3, selectedFDO: user }
                })
                break;

            case HomeActivityType.SAMPLE_TO_SALE:
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
                    state: { selectedActivity: HomeActivityType.SAMPLE_TO_SALE, selectedActivityId: 4, selectedFDO: user }
                })
                break;
            default:
                break;
        }
    }

    getActivityItem = (item) => {
        this.setState({
            selectedActivityItem: item
        });

        if (item.activity_type_id === ActivityType.SAMPLE_TO_SALE && item.activity_status_id === ActivityStatusType.TO_START) {
            const session = AuthService.getSession();
            if (item?.assigned_user_id === session?.user?.user_id) {
                this.handleListClick(item);
            }
        }

        //For View Activity Details
        if (item.activity_status_id === ActivityStatusType.PENDING_REVIEW ||
            item.activity_status_id === ActivityStatusType.TO_RESUBMIT ||
            item.activity_status_id === ActivityStatusType.COMPLETED) {

            if (item.activity_type_id === ActivityType.GROUP_MEETING) {
                this.props.history.push({
                    pathname: ALL_ROUTES.GROUP_MEETING_VIEW_ROUTE,
                    state: { data: item }
                });
            } else if (item.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                item.isEdit = false;
                this.props.history.push({
                    pathname: ALL_ROUTES.SAMPLE_TO_SALE_VIEW_ROUTE,
                    state: { data: item }
                });
            } else {
                this.props.history.push({
                    pathname: ALL_ROUTES.ACTIVITY_DETAILS_ROUTE,
                    state: { activity: item }
                });
            }
            return;
        }
    }

    handleActivityItem = (item) => {
        Utilities.LogPrint("View Details", item);
        const { selectedDate } = this.state;
        if (item.activity_type_id === ActivityType.INDIVIDUAL_VISIT && (item.retailer_id === 0 && item.activity_status_id !== 1)) {
            //this.props.history.push(ALL_ROUTES.ACTIVITY_DETAILS_ROUTE);
            this.props.history.push({
                pathname: ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE,
                state: { isFarmer: true, data: item, selectedDate: selectedDate }
            });

        } else if (item.activity_type_id === ActivityType.INDIVIDUAL_VISIT && (item.retailer_id !== 0 && item.activity_status_id !== 1)) {
            this.props.history.push({
                pathname: ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE,
                state: { isFarmer: false, data: item, selectedDate: selectedDate }
            });

        } else if (item.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION && item.activity_status_id !== 1) {
            //this.props.history.push(ALL_ROUTES.SAMPLE_DISTRIBUTION_DETAILS_ROUTE);
            this.props.history.push({
                pathname: ALL_ROUTES.SAMPLE_DISTRIBUTION_DETAILS_ROUTE,
                state: { data: item, selectedDate: selectedDate }
            });

        } else if (item.activity_type_id === ActivityType.GROUP_MEETING && item.activity_status_id !== 1) {
            //this.props.history.push(ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE);
            this.props.history.push({
                pathname: ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE,
                state: { data: item, selectedDate: selectedDate }
            });
        }
    }

    // goToGroupMeeting = () => {
    //     const { selectedActivityItem } = this.state;
    //     this.props.history.push({
    //         pathname: ALL_ROUTES.ADD_GROUP_MEET_ROUTE,
    //         state: { data: selectedActivityItem, krishakInfo: null }
    //     })
    // }

    goToGroupMeeting = () => {
        const { selectedActivityItem, mobileNumber, hostFarmerName, krishakInfo } = this.state;

        const hostInfo = {
            krishak_id: krishakInfo ? krishakInfo.krishak_id : 0,
            phone: mobileNumber,
            name: hostFarmerName,
        }
        Utilities.LogPrint("Host Details", JSON.stringify(hostInfo));

        this.props.history.push({
            pathname: ALL_ROUTES.ADD_GROUP_MEET_ROUTE,
            state: { data: selectedActivityItem, krishakInfo: hostInfo }
        });
    }

    handleDelete = (e, item) => {
        e.preventDefault();
        Utilities.LogPrint("Delete", item);
        if (item != null) {
            SyncServices.updateDeleteActivity(item.key, "false");
            this.getTodayFDOActivities(this.state.user.user_id);
        }

        // If User Online
        if (Utilities.isNetworkConnected()) {
            var params = JSON.stringify({
                activity_id: item.activity_id,
                is_active: 0
            });
            try {
                ApiServices.deleteActivity(params)
                    .then(response => {
                        var status = response.success
                        if (status) {
                            Utilities.LogPrint("deleteActivity", response.message);
                            SyncServices.updateDeleteActivity(item.key, "true");
                            //this.getTodayActivityApi();
                        }
                    })
                    .catch(error => {
                        Utilities.LogPrint("deleteActivity-catch", error);
                    });
            }
            catch (error) {
                Utilities.LogPrint("deleteActivity-error", error);
            }
        }
    }

    handleActivitiesEdit = (e, item) => {
        e.preventDefault();
        Utilities.LogPrint("handleActivitiesEdit", item);
        if (item != null) {
            //this._getActivityByIdApi(item);
            this.props.history.push({
                pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
                state: {
                    isLoading: false,
                    selectedActivity: item.activity_type_name,
                    selectedActivityId: item.activity_type_id,
                    editActivity: item
                }
            });
        }

    }

    handleListClick = (activity) => {
        //Utilities.LogPrint("CARD INFO", activity);
        //item.key = item?.temp_activity_id;
        const { krishakInfo, retailerInfo } = this.state;

        if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id === 0) {
            this.props.history.push({
                pathname: ALL_ROUTES.ADD_FARMER_ROUTE,
                state: { data: activity, isFarmer: true, krishakInfo: krishakInfo }
            });

        } else if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT && activity.retailer_id > 0) {
            this.props.history.push({
                pathname: ALL_ROUTES.ADD_FARMER_ROUTE,
                state: { data: activity, retailerInfo: retailerInfo }
            });

        } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
            this.props.history.push({
                pathname: ALL_ROUTES.ADD_SAMPLE_DISTRIBUTION_ROUTE,
                state: { activity: activity, krishakInfo: krishakInfo }
            });

        } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
            this.props.history.push({
                pathname: ALL_ROUTES.ADD_GROUP_MEET_ROUTE,
                state: { data: activity, krishakInfo: krishakInfo }
            });

        } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
            activity.isEdit = false;
            this.props.history.push({
                pathname: ALL_ROUTES.SAMPLE_TO_SALE_ROUTE,
                state: { activity: activity, krishakInfo: krishakInfo }
            });
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    handleSync = () => {
        const { user } = this.state;
        //this.getTodayFDOActivities(this.state.data.user_id);

        const session = AuthService.getSession();
        if (user.user_id === session?.user.user_id) {
            this.getTodayFDOActivities(user.user_id);

        } else if (user.is_employee === 1) {
            this.getTodayTMActivities(user.user_id);

        } else {
            this.getTodayFDOActivities(user.user_id);
        }
    }

    render() {
        const { todayData, fdoList, searchedValue, mobileNumber, user, activityList, pendingActivityList, isLoading, isSyncLoading, tableName, hostFarmerName } = this.state;

        const showAddIndividualVisit = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_INDIVIDUAL_VISIT);
        const showAddSampleDistribution = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_SAMPLE_DISTRIBUTION);
        const showAddGroupMeet = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_GROUP_MEETING);
        const showAddSampleToSale = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_SAMPLE_TO_SALE);

        const mainActivityListItem = activityList?.map((activity, i) =>
            <ActivityItem activity={activity} key={i} getActivityItem={this.getActivityItem} handleDelete={this.handleDelete} handleActivitiesEdit={this.handleActivitiesEdit} />
        );

        const pendingActivityListItem = pendingActivityList?.map((activity, i) =>
            <ActivityItem activity={activity} key={i} getActivityItem={this.getActivityItem} handleDelete={this.handleDelete} handleActivitiesEdit={this.handleActivitiesEdit} />
        );

        let filteredFdoLists = fdoList.filter(fdoitem => {
            return (fdoitem.name.toLowerCase().includes(searchedValue.toLowerCase()))
        });


        let fdoListItem = filteredFdoLists.map((item, i) => {
            let name = item.name;
            if (searchedValue !== "") {
                let term = new RegExp(searchedValue, "gi");
                name.replace(term, function (matched) {
                    return '<span className="highlight"> ' + matched + ' </span>';
                })
            }
            return (
                <li key={i}>
                    <a data-toggle="modal" data-target="#selectIndividualVisit" data-dismiss="modal"
                        onClick={this._selectFDO.bind(this, item)}>
                        {item.name}
                    </a>
                </li>
            )
        });

        const enabledHostFarmerGo = (mobileNumber.length === 10 && hostFarmerName?.length > 0);
        const enabledGo = (mobileNumber.length === 10);
        let startTimeStr = HOME_TODAY_SCREEN.DAY_STARTED + " @ --:--";
        let endTimeStr = HOME_TODAY_SCREEN.DAY_ENDED + " @ --:--";

        if (todayData?.start_time !== undefined && todayData?.start_time !== null) {
            startTimeStr = HOME_TODAY_SCREEN.DAY_STARTED + " @ " + todayData?.start_time;
        }
        if (todayData?.end_time !== undefined && todayData?.end_time !== null) {
            endTimeStr = HOME_TODAY_SCREEN.DAY_ENDED + " @ " + todayData?.end_time;
        }

        let userName = "";
        if (user !== null) {
            userName = user?.name
        }

        let headerTitle = HOME_TODAY_SCREEN.TODAYS_ACTIVITIES_FOR + userName;

        const cropGroups = DataProvider.getInstance().getCropGroups();
        let isVc = false;
        if (cropGroups?.length > 0) {
            isVc = cropGroups.some(item => item.crop_group_id === CROP_GROUP.VEGETABLE_CROPS);
        }

        return (
            <div>
                <Header selectedTab={HeaderTypes.TODAY} handleSyncLoading={this.handleSyncLoading} handleSync={this.handleSync} />
                <Footer isActive={2} />

                <div className="container pt-35 pb-65">
                    <div className="row">
                        <div className="col-12">
                            <div className="float-left">
                                <h3 className="title">{headerTitle}</h3>
                                <p className="sub-title">Village</p>
                            </div>
                            <button className="btn btn-primary float-right mt-2 w-182 d-none d-lg-block"
                                onClick={this.handleBack}>{COMMON.BACK}
                            </button>
                        </div>
                    </div>

                    <div className="row mt-3 fod-mobile">
                        <div className="col-6 col-md-6 col-lg-6 col-xl-3">
                            <div className="panel-button-wrapper d-flex">
                                <div className="count yellow">{todayData?.IV}</div>
                                <span>{HOME_TODAY_SCREEN.INDIVIDUAL_VISIT}</span>
                                <a className={showAddIndividualVisit?.view ? "" : "d-none"} data-toggle="modal" data-target="#selectFDO">
                                    <i className="customic ic-add"></i>
                                </a>
                            </div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-6 col-xl-3">
                            <div className="panel-button-wrapper d-flex">
                                <div className="count brown">{todayData?.SD}</div>
                                <span>{HOME_TODAY_SCREEN.SAMPLE_DISTRIBUTION}</span>
                                <a className={(showAddSampleDistribution?.view && isVc) ? "" : "d-none"}
                                    onClick={() => this._handleAddActivity(HomeActivityType.SAMPLE_DISTRIBUTION)}>
                                    <i className="customic ic-add"></i>
                                </a>
                            </div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-6 col-xl-3">
                            <div className="panel-button-wrapper d-flex">
                                <div className="count blue">{todayData?.GM}</div>
                                <span>{HOME_TODAY_SCREEN.GROUP_MEET}</span>
                                <a className={showAddGroupMeet?.view ? "" : "d-none"} onClick={() => this._handleAddActivity(HomeActivityType.GROUP_MEET)}>
                                    <i className="customic ic-add"></i>
                                </a>
                            </div>
                        </div>
                        <div className="col-6 col-md-6 col-lg-6 col-xl-3">
                            <div className="panel-button-wrapper d-flex">
                                <div className="count green">{todayData?.S2S}</div>
                                <span>{HOME_TODAY_SCREEN.SAMPLE_TO_SALE}</span>
                                <a className={showAddSampleToSale?.view ? "" : "d-none"} onClick={() => this._handleAddActivity(HomeActivityType.SAMPLE_TO_SALE)}>
                                    <i className="customic ic-add"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* FDO DESIGN */}
                    <div className="row">
                        <div className="col-12">
                            <div className="row d-none">
                                <div className="col-12 pt-lg-3 pb-lg-0 pt-2 pb-2">
                                    <span className="fod-time">{startTimeStr}</span>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 px-sm-3 px-0 pt-lg-3 pb-lg-0 pt-2 pb-2">
                                    <ul className="fod-list">
                                        {mainActivityListItem}
                                    </ul>
                                </div>
                            </div>

                            <div className="row pending-activities">
                                <div className="col-12 px-sm-3 px-0">
                                    <div className="pending-act-header collapsed" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                                        <a href="/#" className="mr-auto font-weight-bold">{HOME_TODAY_SCREEN.PENDING_ACTIVITIES}</a>
                                        <i className="customic ic-go-button"></i>
                                    </div>
                                </div>
                                <div className="col-12 px-sm-3 px-0 pending-act-body collapse" id="collapseExample">
                                    <ul className="fod-list">
                                        {pendingActivityListItem}
                                    </ul>
                                </div>
                            </div>

                            <div className="row d-none">
                                <div className="col-12 pt-lg-3 pb-lg-0 pt-2 pb-2">
                                    <span className="fod-time">{endTimeStr}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <button className="btn btn-primary float-right mt-2 mb-3 w-100 d-block d-lg-none"
                                onClick={this.handleBack}>{COMMON.BACK}
                            </button>
                        </div>
                    </div>

                </div>

                {/* SELECT FDO POPUP */}
                <div className="modal fade bottom-drawer" id="selectFDO" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>

                                <h6>Select FDO</h6>
                                <div className="form-group search-box">
                                    <input type="text" className="form-control" placeholder="Search" onChange={this._handleChange} />
                                    <i className="customic ic-search"></i>
                                </div>
                                <ul className="drawer-menu-list search-list">
                                    {fdoListItem}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>


                {/* FARMER & RETAILER POPUP */}
                <div className="modal fade bottom-drawer" id="selectIndividualVisit" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>

                                <h6 className="font-weight-medium">{HOME_TODAY_SCREEN.INDIVIDUAL_VISIT} to</h6>
                                <ul className="drawer-menu-list">
                                    <li>
                                        <a onClick={() => this._handleAddActivity(HomeActivityType.INDIVIDUAL_VISIT_FARMER)} data-dismiss="modal">
                                            {HOME_TODAY_SCREEN.FARMER}
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => this._handleAddActivity(HomeActivityType.INDIVIDUAL_VISIT_RETAILER)} data-dismiss="modal">
                                            {HOME_TODAY_SCREEN.RETAILER}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* MOBILE NUMBER POPUP */}
                <div className="modal fade bottom-drawer" id="homeFarmerMobileModal" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h6 className="font-weight-medium">{HOME_TODAY_SCREEN.ENTER_THE_MOBILE_NUMBER_OF_THE_FARMER}</h6>
                                <form action="">
                                    <div className="form-group mobile-number-input">
                                        <label>+91 -</label>
                                        <input type="tel" className="form-control" placeholder="" maxLength="10" onChange={this.verifyNumber} />
                                    </div>

                                    <button className="btn btn-primary w-100 mb-2"
                                        onClick={this.getKrishakByReferenceIdApi}
                                        data-dismiss="modal"
                                        disabled={!enabledGo}
                                    >{HOME_TODAY_SCREEN.GO}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Join Group Bottom Drawers */}
                <div className="modal fade bottom-drawer" id="joinGroupMeeting" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>

                                <h6 className="font-weight-medium">Are you conducting group meeting at the field of the farmer?</h6>
                                <ul className="drawer-menu-list">
                                    <li>
                                        <a data-toggle="modal"
                                            data-target="#homeFarmerMobileModal"
                                            data-dismiss="modal"
                                            onClick={() => this.setState({ isHost: false })}
                                        >YES</a>
                                    </li>
                                    <li>
                                        <a data-toggle="modal"
                                            data-dismiss="modal"
                                            data-target="#hostFarmerMobileModal"
                                            onClick={() => this.setState({ isHost: true })}
                                        >NO</a>
                                    </li>
                                    {/* <li>
                                        <a data-dismiss="modal"
                                            onClick={this.goToGroupMeeting}>NO</a>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* MOBILE NUMBER & HOST FARMER POPUP */}
                <div className="modal fade bottom-drawer" id="hostFarmerMobileModal" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h6 className="font-weight-medium">{HOME_TODAY_SCREEN.ENTER_THE_MOBILE_NUMBER_OF_THE_FARMER}</h6>
                                <form action="">
                                    <div className="form-group mobile-number-input">
                                        <label>+91 -</label>
                                        <input type="tel"
                                            className="form-control"
                                            maxLength="10"
                                            name="mobileNumber"
                                            onChange={this.verifyNumber} />
                                    </div>

                                    <label>Host Farmer Name</label>
                                    <div className="form-group">
                                        <input type="text"
                                            className="form-control"
                                            value={hostFarmerName}
                                            placeholder="Enter Name"
                                            onChange={(event) => {
                                                this.setState({ hostFarmerName: event.target.value });
                                            }} />
                                    </div>

                                    <button className="btn btn-primary w-100 mb-2"
                                        onClick={this.goToGroupMeeting}
                                        data-dismiss="modal"
                                        disabled={!enabledHostFarmerGo}
                                    >{HOME_TODAY_SCREEN.GO}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <DesktopFooter />
                {isLoading ? <Loader /> : null}
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
            </div>
        )
    }
}

export default withRouter(ManagerFdoDetail)